import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { metricFormatAthlete } from "../../../utils/utils";
import "../athlete-objectives.css";
import { optionLogsBase } from "../constants";
const Step2Objectives = ({
  userValoration,
  userObjectives,
  setFormData,
  formData,
  control,
}) => {
  const log = control
    ? userObjectives?.body_composition_goals || {}
    : userValoration?.body_data || {};

  const objectivesInfo = userObjectives?.body_composition_goals || {};

  const optionLogs = optionLogsBase.map((item) => ({
    ...item,
    value: objectivesInfo?.[item.label] || null,
    valorationValue: control
      ? log?.[item.label.replace("_goal", "_actual")] || null
      : log?.[item.logKey]?.[0]?.log_numeric || null,
    scale: control
      ? metricFormatAthlete(
          item.scaleId,
          log?.[item.label.replace("_goal", "_actual")] || null,
          userValoration?.personal_information
        )
      : metricFormatAthlete(
          item.scaleId,
          log?.[item.logKey]?.[0]?.log_numeric || null,
          userValoration?.personal_information
        ),
  }));

  const checkBoxAction = (name, family, name_actual, value_actual) => {
    const familyObj = { ...(formData?.[family] || {}) };

    if (familyObj.hasOwnProperty(name)) {
      delete familyObj[name];
      delete familyObj[name_actual];
    } else {
      familyObj[name] = formData?.[family]?.[name] || null;
      familyObj[name_actual] = value_actual || null;
    }

    const updatedFormData = { ...formData };
    if (Object.keys(familyObj).length === 0) {
      delete updatedFormData[family];
    } else {
      updatedFormData[family] = familyObj;
    }

    setFormData(updatedFormData);
  };
  return (
    <div className="h-100">
      <div className="d-flex justify-content-between ps-4 pb-2">
        <span className="label-step-objectives">
          3. Objetivos de construcción de composición corporal
        </span>
      </div>
      <div
        className="step2-card input_info_athlete p-2 w-100 h-100"
        style={{ maxHeight: "94%" }}
      >
        <div className="d-flex px-2 align-items-center col-12">
          <div className="col-2 d-flex align-items-center justify-content-center"></div>
          <div className="col-8 d-flex align-items-center justify-content-center labels-corporal ">
            Valores actuales
          </div>
          <div className="col-2 d-flex align-items-center  labels-corporal">
            Valor objetivo
          </div>
        </div>
        {optionLogs && optionLogs.length > 0 ? (
          <PerfectScrollbar className=" d-flex p-2 flex-column">
            {optionLogs.map((elemento) =>
              elemento ? (
                <div
                  key={elemento.id}
                  className="d-flex py-2 px-2 align-items-center col-12"
                >
                  <div
                    className="col-2 d-flex align-items-center justify-content-center pb-1 gap-2"
                    style={{
                      textAlign: "right",
                    }}
                  >
                    <div className="col-6 d-flex align-items-center justify-content-center">
                      <label className="custom-checkbox ">
                        <input
                          type="checkbox"
                          name="user"
                          onClick={() =>
                            checkBoxAction(
                              elemento.label,
                              "body_composition_goals",
                              elemento.label_actual,
                              elemento.valorationValue
                            )
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div
                      className="col-6"
                      style={{
                        width: "calc(0.7rem + 0.5vw)",
                        height: "calc(0.7rem + 0.5vw)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {elemento.image}
                    </div>
                  </div>

                  <div
                    className="col-8 d-flex pb-1 align-items-center px-2"
                    style={{
                      borderBottom: "1px solid var(--elevvaTextTitle)",
                    }}
                  >
                    <div
                      className="col-4"
                      style={{ textAlign: "left", lineHeight: "1" }}
                    >
                      <span className="">{elemento.name}</span>
                    </div>
                    <div className="col-4" style={{ textAlign: "center" }}>
                      <span
                        style={{
                          color:
                            elemento.scale == "NORMAL" ||
                            elemento?.scale == "---"
                              ? ""
                              : "rgb(49, 119, 190)",
                        }}
                      >
                        {elemento.scale}
                      </span>
                    </div>
                    <div className="col-4" style={{ textAlign: "right" }}>
                      <span>
                        {elemento?.valorationValue?.toFixed(2) || "---"}
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-2 pb-1 px-1 d-flex align-items-center justify-content-center"
                    style={{ textAlign: "right" }}
                  >
                    <input
                      disabled={
                        !formData?.["body_composition_goals"]?.hasOwnProperty(
                          elemento.label
                        )
                      }
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          body_composition_goals: {
                            ...prev.body_composition_goals,
                            [elemento.label]: Number(e.target.value),
                          },
                        }));
                      }}
                      name={elemento.label}
                      type="number"
                      className="input-corporal"
                      value={
                        formData?.["body_composition_goals"]?.[
                          elemento.label
                        ] || ""
                      }
                    />
                  </div>
                </div>
              ) : null
            )}
          </PerfectScrollbar>
        ) : (
          <div className="d-flex mx-1 my-2" style={{ alignItems: "center" }}>
            <span
              className=" text-objective-jus"
              style={{ fontSize: "calc(.4rem + .3vw)" }}
            >
              No tiene objetivos asignados
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Step2Objectives;
